export interface Rule {
  rule_id: string;
  rule_name: string;
  price_modifier: string;
  price_type: string;
  calculated_amount: string;
  description?: string;
  is_required?: boolean;
  is_custom?: boolean;
}

export const separateRules = (rules: Rule[]) => {
  const required = rules.filter(r => r.is_required);
  const custom   = rules.filter(r => !r.is_required);
  return { required, custom };
};
